import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import { Link } from "gatsby";

function Frame1() {
  return (
    <>
      <Container fluid className="hp-page hp-page--blue-dark px-0">
        <Container>
          <Row>
            <Col className="d-flex justify-content-center align-items-center flex-column text-center text-light mt-0 mt-md-4 mt-lg-5">
              <h1 className="hp-title text-light text-left">
                We Build Weather &amp; Disease Platforms for Agriculture
              </h1>
              <h5 className="hh5-text text-left pt-3">
                Our goal is to provide growers, agronomists, and researchers
                with the best tools to enable more sustainable agriculture.
              </h5>
            </Col>
            <Col
              xs={12}
              md={6}
              className="d-flex justify-content-center align-items-center w-100"
            >
              <div className="hp-weather-machine">
                <Image
                
                  src={
                    process.env.GATSBY_S3_BUCKET_ASSETS +
                    "images/weather_machine.png"
                  }
                  height="540"
                  width="540"
                  alt="Weather Machine"
                  fluid
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Frame1;
